enum TenantManagementView {
  Profile = "CHANGE YOUR DETAILS",
  ManageUsers = "MANAGE USERS",
}

export default TenantManagementView;
